export class AttbJobAlert {
    FrequencyId: number;
    Id: number;
    DesiredKewords: string;
    DesiredLocation: string;
    Radius: number;
    JobType: number;
    JobContract: number;
    MinimumSalary: number;
    MaximumSalary: number;
    UserId:number;
    ModifiedOn:Date;
    CreatedOn:Date;
    
    JobDurationId?: any;
    SalaryCurrencyId: number;
    SalaryRangeId:number;
}
